"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowInstructionDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const show_instruction_json_1 = require("./show-instruction-json");
exports.ShowInstructionDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('ShowInstruction', show_instruction_json_1.ShowInstructionJsonMapper);
